import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../store/zustand/authStore";
import AdminService from "../services/admin.service";

export const useLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { login, logout } = useAuthStore((state) => ({
    login: state.login,
    logout: state.logout,
  }));

  const navigate = useNavigate();

  const handleLogin = async ({ email, password }) => {
    setLoading(true);
    setError(null);

    try {
    const { user, token } = await AdminService.signin({ email, password });
    login(user, token);
    navigate("/");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    setLoading(true);
    setError(null);

    try {
      logout();
      navigate("/login");
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { handleLogin, handleLogout, loading, error };
};
